import { h } from 'vue'

/* =========================================================
 * Base props helper (optional, keeps things consistent)
 * ======================================================= */
const base = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 24 24',
  fill: 'currentColor',
}

type IconProps = Record<string, unknown>

/* =========================================================
 * ELO (abstract ELO mark, favicon-based)
 * ======================================================= */
export const IconElo = (props: IconProps) =>
  h('svg', { ...base, viewBox: '0 0 80 80', ...props }, [
    h('g', { transform: 'translate(0, 17)' }, [
      h('path', {
        d: 'M21.46,18.32v8.09h1.82c4.85-.09,6-.09,7.92-.22l.27.27c-.18,2.31-.23,2.84-.32,5.25l-.26.26H23.77c-5.55,0-6.76,0-9.56.14L14,31.84c.09-3.51.13-6,.13-11.74,0-6.36,0-14.59-.31-19.3L14,.53c5.55,0,11.47,0,16.67-.08l.22.22c-.18,2.13-.18,2.71-.26,4.93l-.27.27h-.8c-1.34,0-2.71,0-4.05,0H21.33c0,3.15,0,3.95,0,7.38h1.91c2.32,0,3.69-.05,6.72-.14l.27.27c-.18,2.27-.18,2.58-.27,4.76l-.27.26c-2.13,0-4.27,0-6.4,0Z',
      }),
      h('path', {
        d: 'M43,.71c-.13,4.36-.13,5.74-.13,13.16,0,2.63,0,6.81,0,9.43,0,1.47,0,2.27.08,3.11h1.38c4.54-.08,5.43-.13,7.52-.26l.26.26c-.17,2.4-.22,3.12-.26,5.34l-.27.22H40.18c-1.87.05-2.13.05-4.53.09l-.27-.22c0-1.78,0-4.4,0-8.49,0-.23,0-18.33-.17-22.51l.22-.26c3.38,0,4.31,0,7.25-.14Z',
      }),
      h('path', {
        d: 'M77.18,9.47a25.36,25.36,0,0,1,.8,6.94,25.88,25.88,0,0,1-.67,6.13c-1.51,6.5-5.78,10-12.27,10a11.87,11.87,0,0,1-9.47-4.18c-2-2.53-3.29-6.49-3.29-11.83C52.28,6.23,56.63,0,65.26,0,71.44,0,75.53,3.29,77.18,9.47ZM70.11,12c-.31-2.27-1.25-6.62-4.89-6.62-4.81,0-5.34,7.47-5.34,11,0,1.33.09,5.34,1.29,7.87a4.43,4.43,0,0,0,4,2.94,3.84,3.84,0,0,0,2.18-.67c2.85-2,3-8,3-10.18A36.18,36.18,0,0,0,70.11,12Z',
      }),
      h('polygon', {
        points: '0 0.54 14.08 0.53 0 14.49 0 0.54',
        fill: 'currentColor',
      }),
    ]),
  ])

/* =========================================================
 * SYNAXON (symbol-only, no text)
 * ======================================================= */
export const IconSynaxon = (props: IconProps) =>
  h('svg', { ...base, viewBox: '0 0 670 670', ...props }, [
    h('g', { transform: 'translate(5, 45)' }, [
      h('path', {
        d: 'M660.3,556l-98.5-340.6c-2-6.8-10-9.8-15.9-6L5.3,550c-8.8,5.7-4.9,19.4,5.6,19.5H650 C657.1,569.6,662.2,562.8,660.3,556z',
      }),
      h('path', {
        d: 'M159.1,324.3c1.8,6.1,8.9,8.8,14.2,5.3L656,25.5c7.9-5.1,4.3-17.3-5-17.4H80.5c-6.3-0.1-11,6-9.2,12.1 L159.1,324.3z',
        fill: 'currentColor',
        opacity: 0.8,
      }),
    ]),
  ])

/* =========================================================
 * Microtech (abstracted corporate mark)
 * ======================================================= */
export const IconMicrotech = (props: IconProps) =>
  h(
    'svg',
    {
      ...base,
      viewBox: '0 0 124 124',
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': '10',
      'stroke-linecap': 'square',
      'stroke-linejoin': 'square',
      ...props,
    },
    [
      // Diamond symbol (st0)
      h('path', {
        d: 'M113.5,72.9c-1.5,1.5-4.1,1.5-5.6,0l-8.4-8.4c-1.5-1.5-1.5-4.1,0-5.6l8.4-8.4c1.5-1.5,4.1-1.5,5.6,0l8.4,8.4 c1.5,1.5,1.5,4.1,0,5.6L113.5,72.9z',
      }),
      // Main symbol part (st1)
      h('path', {
        d: 'M85.4,64.5c-1.5-1.5-4.1-1.5-5.6,0L64.3,80c-0.8,0.8-1.8,1.2-2.8,1.2l0,0c-1,0-2-0.4-2.8-1.2L43.2,64.5 c-1.5-1.5-1.5-4.1,0-5.6l15.5-15.5c0.6-0.6,1.3-0.9,2.1-1.1c0.1,0,0.1,0,0.2,0c1.2-0.2,2.5,0.2,3.4,1.1l15.5,15.5 c1.5,1.5,4.1,1.5,5.6,0L101,43.4c1.5-1.5,1.5-4.1,0-5.6L85.5,22.3c-1.5-1.5-4.1-4.1-5.6-5.6L64.4,1.2c-1-1-2.3-1.3-3.6-1.1h-0.1 c-0.2,0-0.4,0.1-0.7,0.2c-0.5,0.2-0.9,0.5-1.3,0.9L43.2,16.7c-0.8,0.8-1.8,1.8-2.8,2.8s-2,2-2.8,2.8L29.9,30l-7.7,7.7 c-0.8,0.8-1.8,1.8-2.8,2.8s-2,2-2.8,2.8L1.1,58.8c-1.5,1.5-1.5,4.1,0,5.6l57.7,57.7c0.4,0.4,0.8,0.7,1.3,0.9 c0.2,0.1,0.4,0.1,0.7,0.2h0.1c1.3,0.2,2.6-0.1,3.6-1.1L80,106.6c1.5-1.5,4.1-4.1,5.6-5.6l15.5-15.5c1.5-1.5,1.5-4.1,0-5.6 L85.4,64.5z',
      }),
    ],
  )

/* =========================================================
 * Insiders Technologies (IT monogram)
 * ======================================================= */
export const IconInsiders = (props: IconProps) =>
  h('svg', { ...base, ...props }, [
    // I
    h('rect', {
      x: 5,
      y: 4,
      width: 3,
      height: 16,
      rx: 1,
    }),

    // T top
    h('rect', {
      x: 10,
      y: 4,
      width: 9,
      height: 3,
      rx: 1,
    }),

    // T stem
    h('rect', {
      x: 13,
      y: 7,
      width: 3,
      height: 13,
      rx: 1,
    }),
  ])

/* =========================================================
 * Mail icon (with thicker strokes)
 * ======================================================= */
export const IconMail = (props: IconProps) =>
  h(
    'svg',
    {
      ...base,
      viewBox: '0 0 24 24',
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': '2.5',
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      ...props,
    },
    [
      h('path', {
        d: 'M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75',
      }),
    ],
  )

/* =========================================================
 * E-Invoice (paper with Euro symbol)
 * ======================================================= */
export const IconInvoice = (props: IconProps) =>
  h(
    'svg',
    {
      ...base,
      viewBox: '0 0 24 24',
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': '2',
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      ...props,
    },
    [
      h('path', {
        d: 'M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z',
      }),
      h('path', {
        d: 'M14.25 15.531c0-1.041-.639-1.96-1.587-2.46-.359-.19-.732-.346-1.119-.468-.492-.156-.989-.243-1.481-.261-.48-.017-.962.015-1.437.095-.363.062-.719.16-1.066.294-.421.163-.82.378-1.187.643a3.001 3.001 0 0 0-1.123 2.157m7.5 0c0 .532-.186 1.037-.502 1.442-.317.404-.75.72-1.248.948-.498.228-1.05.345-1.62.345-1.14 0-2.12-.468-2.76-1.218-.321-.375-.544-.816-.653-1.288-.11-.47-.119-.958-.027-1.432.09-.474.288-.925.572-1.32.284-.396.657-.723 1.096-.96.44-.236.936-.364 1.455-.364.519 0 1.015.128 1.454.364.44.237.813.564 1.097.96.284.395.481.846.572 1.32.092.474.083.961-.027 1.432-.11.472-.333.913-.654 1.288z',
      }),
    ],
  )

/* =========================================================
 * Notification (Bell icon)
 * ======================================================= */
export const IconNotification = (props: IconProps) =>
  h(
    'svg',
    {
      ...base,
      viewBox: '0 0 24 24',
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': '2',
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      ...props,
    },
    [
      h('path', {
        d: 'M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0',
      }),
    ],
  )

/* =========================================================
 * Workflow (Lucide-style Workflow icon)
 * ======================================================= */
export const IconWorkflow = (props: IconProps) =>
  h(
    'svg',
    {
      ...base,
      viewBox: '0 0 24 24',
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': '2',
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      ...props,
    },
    [
      h('rect', {
        x: '3',
        y: '3',
        width: '6',
        height: '6',
        rx: '1',
      }),
      h('rect', {
        x: '15',
        y: '15',
        width: '6',
        height: '6',
        rx: '1',
      }),
      h('path', {
        d: 'M9 6h6a2 2 0 0 1 2 2v7',
      }),
      h('path', {
        d: 'm12 12 3 3 3-3',
      }),
    ],
  )

/* =========================================================
 * Emergency (Lucide Life Buoy icon)
 * ======================================================= */
export const IconEmergency = (props: IconProps) =>
  h(
    'svg',
    {
      ...base,
      viewBox: '0 0 24 24',
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': '2',
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      ...props,
    },
    [
      h('circle', { cx: '12', cy: '12', r: '10' }),
      h('circle', { cx: '12', cy: '12', r: '4' }),
      h('line', { x1: '4.93', y1: '4.93', x2: '9.17', y2: '9.17' }),
      h('line', { x1: '14.83', y1: '14.83', x2: '19.07', y2: '19.07' }),
      h('line', { x1: '14.83', y1: '9.17', x2: '19.07', y2: '4.93' }),
      h('line', { x1: '4.93', y1: '19.07', x2: '9.17', y2: '14.83' }),
    ],
  )

/* =========================================================
 * Optional: single export map (nice for dynamic usage)
 * ======================================================= */
export const VendorIcons = {
  elo: IconElo,
  synaxon: IconSynaxon,
  microtech: IconMicrotech,
  insiders: IconInsiders,
  mail: IconMail,
  invoice: IconInvoice,
  notification: IconNotification,
  workflow: IconWorkflow,
  emergency: IconEmergency,
}
